import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { ActionAlert } from 'components/shared/Alerts/ActionAlert/ActionAlert'
import { AssessmentForm } from '../../features/AssessmentForm/AssessmentForm'
import { Questions } from '../../features/Questions/Questions'

import {
  InterviewHandlersContext,
  InterviewStateContext,
} from 'components/modules/interview/context'
import { useContext } from 'hooks'

import styles from './CategoryDetails.module.scss'

export const CategoryDetails = () => {
  const state = useContext(InterviewStateContext)
  const handlers = useContext(InterviewHandlersContext)

  const [activeIndex, setActiveIndex] = React.useState(0)

  const {
    activeSection: { key, questions = [], scoreable, title },
    assessment: { control, fields, watch },
    isReadOnly,
  } = state
  const { handleAddSelf } = handlers

  return (
    <Box
      align="center"
      className={styles.details}
      direction="column"
      tagName="section"
    >
      <Box className={styles.content} direction="column">
        <ActionAlert
          buttonLabel={t`Add yourself`}
          className={styles.alert}
          message={t`You need to be on the evaluators list in order to make assessments.\nAdd yourself by clicking on the button.`}
          variant="warning"
          onAction={handleAddSelf}
          isInitialised={isReadOnly}
        />
        <h2 className={styles.title}>{title}</h2>
        <Questions {...{ activeIndex, questions, setActiveIndex }} />
        {R.and(scoreable, !isReadOnly) ? (
          <AssessmentForm
            index={R.findIndex(R.propEq('key', key), fields)}
            {...{ control, watch }}
          />
        ) : null}
      </Box>
    </Box>
  )
}
